import gql from 'graphql-tag'

const SEND_POTENTIAL_PARTNER_EMAIL = gql`
  mutation SendPotentialPartnerEmail(
    $name: String!
    $email: String
    $company: String
    $message: String
  ) {
    sendPotentialPartnerEmail(
      input: {
        name: $name
        email: $email
        company: $company
        message: $message
      }
    ) {
      errors {
        code
        message
      }
    }
  }
`

export default SEND_POTENTIAL_PARTNER_EMAIL
